import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootStateType } from '../redux-store/reducers'; // Import your root state type if you have one
import { featureToggles } from '../redux-store/actions';
import { togglerType } from '../redux-store/types/mdms';

export const useFeatureToggles = () => {
  const dispatch = useDispatch();
  const dateFeatureToggles = useSelector(
    (state: RootStateType) => state.toggler.dateFeatureToggles
  );

  useEffect(() => {
    const shouldFetch = !Object.values(dateFeatureToggles).some((date) => date);
    if (shouldFetch) {
      dispatch(featureToggles());
    }
  }, [dateFeatureToggles, dispatch]);

  return dateFeatureToggles;
};

export const useMdmsFatcaData = () => {
  const dispatch = useDispatch();
  const { application } = useSelector((state: RootStateType) => state.application);
  const [fatcaToFetch, setFatcaToFetch] = useState<string>('');

  useEffect(() => {
    (async function () {
      try {
        if (Object.keys(application || {}).length !== 0) {
          const { fatcaMasterDataFeatureToggle } = await dispatch(
            featureToggles() as unknown as togglerType
          );
          const dates: string[] = Object.keys(fatcaMasterDataFeatureToggle).sort(
            (a, b) => new Date(b).getTime() - new Date(a).getTime()
          );

          const givenDate = new Date(application?.createdAt || '');

          // Find the first date less than the given date
          const firstDateLessThanGiven = dates.find(
            (date) => new Date(date).getTime() < givenDate.getTime()
          );
          const fatcaToFetch: string =
            fatcaMasterDataFeatureToggle[firstDateLessThanGiven || ''] || '';
          setFatcaToFetch(fatcaToFetch);
        }
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [dispatch, application]);

  return fatcaToFetch;
};
